import { baseColorPalettes, neutralColors, prefix, productLevelColorSystem } from "./constants";

/**
 * Converts Hexadecimal color value to RGB color value, because Hex color values in tailwind do not support opacity
 * @see https://tailwindcss.com/docs/customizing-colors#using-css-variables
 */
export function hexToRGB(hex: string) {
	// Remove the possible # sign
	hex = hex.replace("#", "");

	// Handle shorthand hex like #000
	if (hex.length === 3) {
		hex = hex.split('').map(char => char + char).join('');
	}

	const r = Number.parseInt(hex.substring(0, 2), 16);
	const g = Number.parseInt(hex.substring(2, 4), 16);
	const b = Number.parseInt(hex.substring(4, 6), 16);

	return `${r} ${g} ${b}`;
}

// Determine if it is an RGB color value
export function isRGBColor(color: any) {
	return typeof color === 'string' && color.trim().startsWith("rgb");
}

// Check if a string is a hex color
export function isHexColor(color: any) {
	return typeof color === 'string' && /^#(?:[A-F0-9]{3}){1,2}$/i.test(color);
}

/**
 * Maps Ant Design tokens and custom tokens to CSS variables
 */
export function getCSSVariablesByTokens(tokens: any) {
	return Object.entries(tokens)
		.reduce((acc, [key, value]): string => {
			// Functional color system
			if (productLevelColorSystem.includes(key)) {
				const rgb = isHexColor(value) ? hexToRGB(value as string) : value;
				return `${acc}--${prefix}-${key}:${rgb};`;
			}

			// Neutral color system (including our custom colorTextSolid)
			if (neutralColors.includes(key)) {
				const rgb = isRGBColor(value) ? value : isHexColor(value) ? `rgb(${hexToRGB(value as string)})` : value;
				return `${acc}--${prefix}-${key}:${rgb};`;
			}

			// Color palette
			if (baseColorPalettes.includes(key) && isHexColor(value)) {
				return `${acc}--${prefix}-${key}:${hexToRGB(value as string)};`;
			}

			return acc;
		}, "");
}
